import {
  Box,
  Textarea as ChakraTextarea,
  TextareaProps,
} from '@chakra-ui/react'
import * as React from 'react'
import { useColor } from '../../../theme'
import { ErrorMessage } from '../ErrorMessage'
import { IFormValidationProps } from '../hooks'

export const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  IFormValidationProps & TextareaProps
>(
  (
    { isInvalid, Label, placeholder, isDisabled, errorMessage, ...rest },
    ref,
  ) => {
    const invalidColor = useColor({ nuance: 'red', palette: 'colors' })

    return (
      <Box>
        {Label && <Label />}
        <ChakraTextarea
          errorBorderColor={invalidColor}
          isDisabled={isDisabled}
          isInvalid={isInvalid}
          placeholder={placeholder}
          ref={ref}
          resize="none"
          {...rest}
        />

        {isInvalid && errorMessage && (
          <ErrorMessage isDisabled={isDisabled}>{errorMessage}</ErrorMessage>
        )}
      </Box>
    )
  },
)
